import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import classes from './SideBySideColumn.module.css';
import LogPostItem from 'components/Log/Timeline/LogPostItem/LogPostItem';
import LogPostItemSmall from 'components/Log/Timeline/LogPostItemSmall/LogPostItemSmall';
import 'assets/custom-riza-plugin-styles/infinite-scroll.css';
import Spinner from 'components/UI/Spinner/Spinner';
import { getMediaThumb } from 'shared/util';
import {
  categoryImages,
  formatPostItemDateRange,
  formatTimeRangeForPostsTableDisplay,
  getFullYearFromStringDate,
  getRgbFromColorName,
  getSeason,
  isSameSeason,
  isSameYear,
} from 'shared/utility';

class SideBySideColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageNumber: 1,
      posts: [],
      // loading: true,
    };
  }

  componentDidMount() {
    if (this.props.multiViewColumnData[this.props.columnKey]) {
      this.setState({ posts: this.props.multiViewColumnData[this.props.columnKey].Posts });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.multiViewColumnData[this.props.columnKey] && prevProps.multiViewColumnData[this.props.columnKey]) {
      // const columnObject = this.props.multiViewColumnData[this.props.columnKey];
      if (this.props.multiViewColumnData[this.props.columnKey].Posts !== prevProps.multiViewColumnData[this.props.columnKey].Posts) {
        this.setState({ posts: this.props.multiViewColumnData[this.props.columnKey].Posts });
      }
      // In the case where the pageNum has changed due to reasons such as the parent component (SideBySideController) refreshing
      // column posts after fitlers have been changed, update this.state.currentPageNumber
      if (this.props.multiViewColumnData[this.props.columnKey].PageNum !== this.state.currentPageNumber)
        this.setState({ currentPageNumber: this.props.multiViewColumnData[this.props.columnKey].PageNum });
    }
  }

  handleFetchMorePosts = () => {
    const updatedPageNumber = this.state.currentPageNumber + 1;
    this.props.handleFetchMultiViewColumns(this.props.type, [this.props.subType], updatedPageNumber);
    this.setState({ currentPageNumber: updatedPageNumber });
  };

  handleScrollToTopOfColumn = () => {
    const scrollContainerDiv = document.getElementById(`scrollableDiv-${this.props.columnNumber}`);
    if (scrollContainerDiv && scrollContainerDiv.getElementsByClassName('infinite-scroll-component')[0]) {
      scrollContainerDiv.getElementsByClassName('infinite-scroll-component')[0].scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  render = () => {
    let columnImage = null;
    const columnKey = this.props.columnKey ? this.props.columnKey : '';
    const columnObject = this.props.multiViewColumnData[columnKey];
    if (this.props.type === 'categories') {
      const columnImageObj = categoryImages.find((category) => category.name === this.props.title);
      columnImage = <columnImageObj.image />;
    } else {
      // There is currently an api bug which causes recently created user profiles that do not have images associated with them to have a broken
      // image url. We therefore include this workaround
      columnImage =
        this.props.columnImgSrc && this.props.columnImgSrc.charAt(this.props.columnImgSrc.length - 1) !== '/' ? (
          <img src={this.props.columnImgSrc} className={classes.ProfileImage} alt={this.props.columnName} />
        ) : (
          <div
            style={{ backgroundColor: this.props.columnColor ? getRgbFromColorName(this.props.columnColor) : '#bee7f5' }}
            className={classes.AvatarContainer}
          >
            <FontAwesomeIcon icon="user" className={classes.UserIcon} />
          </div>
        );
    }
    let timeline = null;
    // const postsArray = columnObject && columnObject.Posts ? columnObject.Posts : [];
    let posts = null;
    const loading =
      columnObject && columnObject.loading !== undefined
        ? columnObject.Posts && columnObject.Posts.length > 0
          ? false
          : columnObject.loading
        : true;
    const morePostsAvailable = columnObject && columnObject.morePostsAvailable !== undefined ? columnObject.morePostsAvailable : false;
    const scrollContainerHeight = `${window.innerHeight - 333}px`;

    if (this.state.posts && this.state.posts.length > 0) {
      posts = this.state.posts.map((post, index) => {
        const displayDate =
          formatPostItemDateRange(post.Post.DateStartCalc, post.Post.DateEndCalc, post.Ongoing) +
          (post.Post.TimeStartCalc
            ? `, ${formatTimeRangeForPostsTableDisplay(post.Post.TimeStartCalc, post.Post.TimeEndCalc, post.Post.Ongoing)}`
            : '');
        let displayYear = null;
        let displaySeason = null;
        if (
          index > 1 &&
          isSameYear(post.Post.DateStartCalc, this.state.posts[index - 1].Post.DateStartCalc) === false &&
          this.state.posts.length !== index &&
          this.props.selectedSortColumn === 'DateStart'
        ) {
          displayYear = this.props.postViewSize === 'large' ? <h2>{getFullYearFromStringDate(post.Post.DateStartCalc)}</h2> : null;
          displaySeason = (
            <h3 className={classes.SeasonName}>
              {this.props.postViewSize === 'large'
                ? getSeason(post.Post.DateStartCalc)
                : `${getSeason(post.Post.DateStartCalc)} ${getFullYearFromStringDate(post.Post.DateStartCalc)}`}
            </h3>
          );
        } else if (
          index > 1 &&
          isSameSeason(post.Post.DateStartCalc, this.state.posts[index - 1].Post.DateStartCalc) === false &&
          this.props.selectedSortColumn === 'DateStart'
        ) {
          displaySeason = (
            <h3 className={classes.SeasonName}>
              {this.props.postViewSize === 'large'
                ? getSeason(post.Post.DateStartCalc)
                : `${getSeason(post.Post.DateStartCalc)} ${getFullYearFromStringDate(post.Post.DateStartCalc)}`}
            </h3>
          );
        }
        return (
          <div id={`post-${post.Post.PostId}`} key={`${post.Post.PostId}-${index}`}>
            <div className={classes.YearAndSeason}>
              {displayYear}
              {!displayYear ? displaySeason : null}
            </div>
            {this.props.postViewSize === 'large' ? (
              <LogPostItem
                postImageUrl={
                  post.Files && post.Files.FileTop
                    ? post.Files.FileTop.MediaType === 'Video'
                      ? post.Files.FileTop.MediumImageURL
                      : post.Files.FileTop.FileURL
                    : null
                }
                handleSelect={this.props.handlePostSelect}
                categoryImage={post.Post.Type ? post.Post.Type : null}
                date={displayDate}
                post={post.Post}
                page="category"
                comments={post.Comments}
                isUnread={post.MyHistory && Object.keys(post.MyHistory).length === 0}
                logId={this.props.Id}
                sortBy={this.props.selectedSortColumn}
                type="SideBySide"
              />
            ) : (
              <LogPostItemSmall
                postImageUrl={
                  post.Files && post.Files.FileTop
                    ? post.Files.FileTop.MediaType === 'Video'
                      ? post.Files.FileTop.MediumImageURL
                      : getMediaThumb(post.Files.FileTop)
                    : null
                }
                handleSelect={this.props.handlePostSelect}
                categoryImage={post.Post.Type ? post.Post.Type : null}
                date={displayDate}
                page="category"
                color={post.Post.Color}
                comments={post.Comments}
                post={post.Post}
                isUnread={post.MyHistory && Object.keys(post.MyHistory).length === 0}
                logId={this.props.Id}
                sortBy={this.props.selectedSortColumn}
                type="SideBySide"
              />
            )}
          </div>
        );
      });
    }

    let initialYearAndSeason = null;
    if (this.state.posts && this.state.posts.length > 0 && this.props.selectedSortColumn === 'DateStart') {
      initialYearAndSeason = (
        <div className={[classes.YearAndSeason, classes.Top].join(' ')}>
          <h2>{getFullYearFromStringDate(this.state.posts[0].Post.DateStartCalc)}</h2>
          <h3 className={classes.SeasonName}>{getSeason(this.state.posts[0].Post.DateStartCalc)}</h3>
        </div>
      );
    }
    if (loading) {
      timeline = <Spinner lightColor />;
    } else if (this.state.posts && this.state.posts.length > 0) {
      timeline = (
        <div
          id={`scrollableDiv-${this.props.columnNumber}`}
          className={
            this.props.postViewSize === 'small'
              ? [classes.ScrollContainer, classes.SmallView].join(' ')
              : [classes.ScrollContainer, classes.LargeView].join(' ')
          }
        >
          <InfiniteScroll
            height={scrollContainerHeight}
            dataLength={this.state.posts.length}
            next={this.handleFetchMorePosts}
            endMessage=""
            loader={<Spinner small lightColor />}
            hasMore={loading ? true : morePostsAvailable}
          >
            {initialYearAndSeason}
            {posts}
          </InfiniteScroll>
        </div>
      );
    } else {
      timeline = null;
    }
    return (
      <div className={classes.SideBySideColumnContainer}>
        <div className={classes.Header}>
          <div className={classes.HeaderImageContainer} onClick={this.handleScrollToTopOfColumn}>
            {columnImage}
          </div>
          <h3>{this.props.title}</h3>
          {this.props.showPreviousArrow ? (
            <div className={[classes.ArrowContainer, classes.Left].join(' ')}>
              <FontAwesomeIcon icon="chevron-left" className={classes.LeftIcon} onClick={() => this.props.handleArrowClick('previous')} />
            </div>
          ) : this.props.showNextArrow ? (
            <div className={[classes.ArrowContainer, classes.Right].join(' ')}>
              <FontAwesomeIcon icon="chevron-right" className={classes.LeftIcon} onClick={() => this.props.handleArrowClick('next')} />
            </div>
          ) : null}
        </div>
        <div className={classes.PostsContainer}>{timeline}</div>
      </div>
    );
  };
}

export default SideBySideColumn;
